import * as React from 'react';
import './SiteLocationPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import Alert from 'react-s-alert';
import { ISiteLocationReduxFormState, initialSiteLocationState } from "../../../reducers/reactReduxForms/siteLocation";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { renderFormControls, RegistrationComponent } from "../../../helpers/formHelper";
import { renderRegistrationFormSaveSuccess, renderRegistrationFormSaveWarning, renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import { TextFormInput, NumberFormInput, CheckboxFormInput } from "../../../components/form/index";
import * as SiteLocationActions from '../../../actions/siteLocations';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { NotificationAlert } from "../../../components/common/index";
import { Form, actions } from 'react-redux-form';
import { InstitutionLookupsLayout } from '../../index';
import * as AuthenticationHelper from '../../../helpers/authentication';

interface ISiteLocationPageParams {
    siteLocationId: number;
}

interface ISiteLocationPageProps {

    form: Dtos.SiteLocation & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ISiteLocationReduxFormState;

    location: Location;
    siteLocationId: number;
    match: match<ISiteLocationPageParams>;
    history: History;

    // From state
    siteLocation: Dtos.SiteLocation;
    lookups: Dtos.Lookup[];

    loadingSiteLocation: boolean;
    loadSiteLocationSuccess: boolean;
    loadSiteLocationFailure: boolean;

    savingSiteLocation: boolean;
    saveSiteLocationSuccess: boolean;
    saveSiteLocationFailure: boolean;

    creatingSiteLocation: boolean;
    createSiteLocationSuccess: boolean;
    createSiteLocationFailure: boolean;

    validationFailures: Dtos.ResponseError[];

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ISiteLocationPageActions {
    clearSiteLocation: SiteLocationActions.ISiteLocationClearActionCreator;
    loadSiteLocation: SiteLocationActions.ISiteLocationLoadByIdActionCreator;

    saveSiteLocation: SiteLocationActions.ISiteLocationSaveActionCreator;
    createSiteLocation: SiteLocationActions.ISiteLocationCreateActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type SiteLocationPageProps = ISiteLocationPageProps & ISiteLocationPageActions;

const reduxFormName: string = "reduxForms.siteLocation";

class SiteLocationPage extends React.PureComponent<SiteLocationPageProps, any> {

    constructor(props: SiteLocationPageProps) {
        super(props);

        this.clearSiteLocation = this.clearSiteLocation.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.loadForm = this.loadForm.bind(this);
    }

    componentDidMount() {
        const {
            loadSiteLocation,
            siteLocationId,
            createSiteLocation
        } = this.props;

        if (siteLocationId) {
            loadSiteLocation(siteLocationId);
        } else if (!siteLocationId) {
            createSiteLocation();
        }
    }

    componentWillReceiveProps(nextProps: SiteLocationPageProps) {
    }

    componentDidUpdate(prevProps: SiteLocationPageProps, prevState) {
        const {
            siteLocationId,
            siteLocation,
            form,
            navigate,
            loadSiteLocation,
            loadingSiteLocation,
            loadSiteLocationSuccess,
            createSiteLocation,
            creatingSiteLocation,
            createSiteLocationSuccess,
            savingSiteLocation,
            saveSiteLocationSuccess,
            validationFailures
        } = this.props;

        if (siteLocationId && prevProps.siteLocationId != siteLocationId) {
            loadSiteLocation(siteLocationId);
        }
        else if (!siteLocationId && prevProps.siteLocationId) {
            createSiteLocation();
        }

        if (!loadingSiteLocation && prevProps.loadingSiteLocation) {
            if (loadSiteLocationSuccess) {
                this.loadForm();
            }
        }

        if (!savingSiteLocation && prevProps.savingSiteLocation) {
            if (saveSiteLocationSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(<NotificationAlert
                        alertContent={renderRegistrationFormSaveWarning(validationFailures)}
                        icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                    />);

                } else {
                    Alert.success(<NotificationAlert
                        alertContent={renderRegistrationFormSaveSuccess()}
                        icon={FontAwesomeIcons.Solid.CHECK}
                    />);
                }
                if (form.saveAndReturn) {
                    navigate("/settings/institution/sitelocations")
                } else if (!form.saveAndReturn && siteLocationId && siteLocationId > 0) {
                    this.loadForm();
                } else if (!form.saveAndReturn && !siteLocationId && siteLocation && siteLocation.id > 0) {
                    navigate("/settings/institution/sitelocations/" + siteLocation.id);
                }
            }
            else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }

        if (!creatingSiteLocation && prevProps.creatingSiteLocation) {
            if (createSiteLocationSuccess) {
                this.loadForm();
            }
        }
    }

    componentWillUpdate(nextProps: SiteLocationPageProps) {
    }

    componentWillUnmount() {
        const {
            resetForm,
            loadForm
        } = this.props

        this.clearSiteLocation();
        loadForm(reduxFormName, initialSiteLocationState);
        resetForm(reduxFormName);
    }

    clearSiteLocation() {
        this.props.clearSiteLocation();
    }

    showSiteLocation(): boolean {
        const {
            loadingSiteLocation,
            loadSiteLocationSuccess
        } = this.props

        if (!loadingSiteLocation && loadSiteLocationSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingSiteLocation
        } = this.props;

        return <InstitutionLookupsLayout loading={loadingSiteLocation} permission={Dtos.Permission.SiteLocationsView}>
            {this.renderContent()}
        </InstitutionLookupsLayout>;
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            savingSiteLocation,
            permissions
        } = this.props;

        const hasPermission: boolean = AuthenticationHelper.hasCreateEditPermission(form, permissions, Dtos.Permission.SiteLocationsUpdate, Dtos.Permission.SiteLocationsCreate);
        const formDisabled: boolean = !hasPermission || savingSiteLocation || (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            value: {
                type: RegistrationComponent.RegistrationControl,
                inputType: TextFormInput,
                inputDisabled: formDisabled,
            },
            rank: {
                type: RegistrationComponent.RegistrationControl,
                inputType: NumberFormInput,
                inputDisabled: formDisabled,
            },
            active: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    label: "Active"
                },
                inputLabel: " ",
            }
        };

        return <div>
            <h1>Site Location</h1>
            <Form model={reduxFormName}
                onSubmit={(val, event) => this.handleOnSubmit(val)}
                onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
            >
                {
                    renderFormControls(form, "siteLocation", formComponents, lookups, validationFailures, formProperties, changeForm)
                }
                <div className="mt-4 mb-4 text-right">
                    <button disabled={formDisabled}
                        onClick={
                            () => {
                                this.props.changeForm(reduxFormName + ".saveAndReturn", false);
                            }
                        }
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>

                    <button disabled={formDisabled}
                        onClick={() => {
                            this.props.changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={this.onCancel} className="btn btn-primary mr-2" > Cancel </button>
                </div>
            </Form>

        </div>

    }

    renderErrorAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was <strong> not </strong> saved.
            </div>

    }

    renderWarningAlert(): any {

        const {
            validationFailures,
        } = this.props

        return <div>
            The form was saved but was invalid with {validationFailures.length} errors.
        </div>

    }

    renderSaveSuccessAlert(): any {
        return <div>The form has been saved successfully</div>
    }

    handleOnSubmit(data: Dtos.SiteLocation) {
        const {
            saveSiteLocation
        } = this.props;

        if (data) {
            let changes: Dtos.Institution = {} as Dtos.Institution;
            saveSiteLocation(Object.assign({ ...data }, changes));
        }
    }


    handleOnSubmitFailed(data: Dtos.SiteLocation) {
        Alert.error(<NotificationAlert
            minWidth={500}
            alertContent={renderRegistrationFormSaveBlock()}
            icon={FontAwesomeIcons.Solid.BAN}
        />);
    }

    onCancel() {
        const {
            navigate
        } = this.props;

        navigate("/settings/institution/sitelocations");
    }

    loadForm() {
        const {
            loadForm,
            siteLocation,
        } = this.props

        let extraData: Dtos.SiteLocation = {} as Dtos.SiteLocation;

        loadForm(reduxFormName, Object.assign({ ...siteLocation }, extraData));
    }

}


const mapStateToProps = (state: ITmdState, ownProps: SiteLocationPageProps): ISiteLocationPageProps => {

    let siteLocation: Dtos.SiteLocation | undefined = !(state.siteLocations.formData instanceof Array) ? state.siteLocations.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        siteLocationId: ownProps.match && ownProps.match.params.siteLocationId && ownProps.match.params.siteLocationId.toString() != "create" ? ownProps.match.params.siteLocationId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        siteLocation: siteLocation!,

        loadingSiteLocation: state.siteLocations.loadState && state.siteLocations.loadState.status == RequestState.Pending,
        loadSiteLocationSuccess: state.siteLocations.loadState && state.siteLocations.loadState.status == RequestState.Success,
        loadSiteLocationFailure: state.siteLocations.loadState && state.siteLocations.loadState.status == RequestState.Failure,

        savingSiteLocation: state.siteLocations.saveState && state.siteLocations.saveState.status == RequestState.Pending,
        saveSiteLocationSuccess: state.siteLocations.saveState && state.siteLocations.saveState.status == RequestState.Success,
        saveSiteLocationFailure: state.siteLocations.saveState && state.siteLocations.saveState.status == RequestState.Failure,

        creatingSiteLocation: state.siteLocations.createState && state.siteLocations.createState.status == RequestState.Pending,
        createSiteLocationSuccess: state.siteLocations.createState && state.siteLocations.createState.status == RequestState.Success,
        createSiteLocationFailure: state.siteLocations.createState && state.siteLocations.createState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
        lookups: [],

        form: state.reduxForms.siteLocation,
        formState: state.siteLocations.formState,
        formProperties: state.siteLocations.formProperties,

        reduxFormState: state.reduxForms.formState.siteLocation,
        validationFailures: siteLocation ?
            state.siteLocations.validationFailures :
            undefined,
    };
};

const mapDispatchToProps = (dispatch): ISiteLocationPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        loadSiteLocation: bindActionCreators(SiteLocationActions.LoadSiteLocationById, dispatch),
        clearSiteLocation: bindActionCreators(SiteLocationActions.Clear, dispatch),

        saveSiteLocation: bindActionCreators(SiteLocationActions.SaveSiteLocation, dispatch),
        createSiteLocation: bindActionCreators(SiteLocationActions.CreateSiteLocation, dispatch),

    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(SiteLocationPage);
